import { Grid } from "@mui/material";

interface PropsContainer {
  columnSpacing?: number;
  rowSpacing?: number;
  gridProps?: React.ComponentProps<typeof Grid>;
  children: React.ReactNode;
}

interface PropsItem {
  desktop?: React.ComponentProps<typeof Grid>["lg"];
  tablet?: React.ComponentProps<typeof Grid>["md"];
  mobile?: React.ComponentProps<typeof Grid>["xs"];
  gridProps?: React.ComponentProps<typeof Grid>;
  children: React.ReactNode;
}

const FormGridContainer: React.FC<PropsContainer> = ({
  columnSpacing = 4,
  rowSpacing = 4,
  gridProps = {},
  children,
}) => {
  return (
    <Grid
      container
      columnSpacing={columnSpacing}
      rowSpacing={rowSpacing}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...gridProps}
    >
      {children}
    </Grid>
  );
};

const FormGridItem: React.FC<PropsItem> = ({
  gridProps,
  mobile = 12,
  desktop = 4,
  tablet,
  children,
}) => {
  return (
    <Grid
      item
      md={tablet || desktop}
      xs={mobile}
      lg={desktop}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...gridProps}
    >
      {children}
    </Grid>
  );
};

export default {
  Container: FormGridContainer,
  Item: FormGridItem,
};
